import { render } from "./ImageAction.vue?vue&type=template&id=4c5d2fae&scoped=true"
import script from "./ImageAction.vue?vue&type=script&lang=js"
export * from "./ImageAction.vue?vue&type=script&lang=js"

import "./ImageAction.vue?vue&type=style&index=0&id=4c5d2fae&scoped=true&lang=css"

import exportComponent from "/Users/ofmartinez/WebDev/orbeas/Holton-OrbeasRogue-Web-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5d2fae"]])

export default __exports__